export default __webpack_public_path__ + "static/media/appconsultadeudas.fe43196b.png";